export default __webpack_public_path__ + "static/media/P730_CoC.980b9cfd.pdf";